import { GET_PRODUCTION_ORDER, RESET_REDUX_STATE, GET_PRODUCTION_REQUIREMENT_DATA } from "../constants";

const initialValue = {
    productionOrderData : "",
    productionRequirementData: []
}

const productionOrder = (state = initialValue, action) => {
    const {type, payload} = action
    switch (type) {
        case GET_PRODUCTION_ORDER: {
            return {
                ...state,
                productionOrderData: payload
            }
        }

        case GET_PRODUCTION_REQUIREMENT_DATA: {
            return {
                ...state,
                productionRequirementData: payload
            }
        }
            
        case RESET_REDUX_STATE: {
            return initialValue
        }    
    
        default: {
            return state
        }
    }
}

export default productionOrder